import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import Utils from '../../../services/UtilsService';
import useStyle from './SelectStyle';
import OptionsPopper from './OptionsPopper';
import Button from '../../material-ui-kit/CustomButtons/Button';

// Modified by AI on 05/26/2026. Edit #1.
const CustomSelect = ({
    testId,
    color = 'transparent',
    className = '',
    selectOptions = [],
    selectedValue = '',
    onOptionSelect = () => {},
    isLeftAligned = true,
    maxListHeight,
    onButtonClick = () => {},
    isLoading = false,
    placement: dropdownPlacement = 'bottom',
}) => {
    const { t } = useTranslation();

    const [isOpen, setOpenState] = useState(false);
    const classes = useStyle({ isOpen, isLeftAligned, maxListHeight });
    const rootClasses = Utils.getClassName([
        classes.root,
        className,
    ]);

    const anchorRef = React.useRef(null);
    const selectedItemLabel = (selectOptions.find(({ value }) => value === selectedValue) || {}).label;

    return (
        <div className={rootClasses}
            data-test-id={testId || 'custom-select'}
            ref={anchorRef}
        >
            <Button
                size={'md'}
                color={color}
                className={classes.activeArea}
                data-test-id='toggle-user-menu-btn'
                onClick={(e) => {
                    e.stopPropagation();

                    setOpenState(true);
                    onButtonClick();
                }}
            >
                <span className={classes.selectedValue}>
                    {t(selectedItemLabel)}
                </span>
                <ArrowDropDown className={classes.arrowDropDown}/>
            </Button>
            <OptionsPopper
                className={'options-popper'}
                testId={testId}
                isOpen={isOpen}
                anchorEl={anchorRef.current}
                placement={dropdownPlacement}
                isLeftAligned={isLeftAligned}
                isLoading={isLoading}
                options={selectOptions}
                onOpenStateChange={setOpenState}
                onOptionSelect={onOptionSelect}
            />
        </div>
    );
};

CustomSelect.propTypes = {
    testId: PropTypes.string,
    className: PropTypes.string,
    selectOptions: PropTypes.array,
    selectedValue: PropTypes.string,
    onOptionSelect: PropTypes.func,
    isLeftAligned: PropTypes.bool,
    color: PropTypes.string,
    onButtonClick: PropTypes.func,
    isLoading: PropTypes.bool,
    placement: PropTypes.oneOf([
        'bottom-end',
        'bottom-start',
        'bottom',
        'left-end',
        'left-start',
        'left',
        'right-end',
        'right-start',
        'right',
        'top-end',
        'top-start',
        'top',
    ]),
    maxListHeight: PropTypes.number,
};

export default CustomSelect;
